"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ButtonGroup", {
  enumerable: true,
  get: function get() {
    return _ButtonGroup["default"];
  }
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));

var _deprecated = _interopRequireDefault(require("../util/deprecated"));

var LeftIcon = function LeftIcon(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("span", null, _react["default"].createElement("span", {
    className: className
  }), "\xA0");
};

LeftIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string
} : {};

var RightIcon = function RightIcon(_ref2) {
  var className = _ref2.className;
  return _react["default"].createElement("span", null, "\xA0", _react["default"].createElement("span", {
    className: className
  }));
};

RightIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string
} : {};

/**
 * A ZSG styled button.
 */
var Button =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Button, _React$Component);

  function Button() {
    (0, _classCallCheck2["default"])(this, Button);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Button).apply(this, arguments));
  }

  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          skin = _this$props.skin,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          fullsize = _this$props.fullsize,
          selected = _this$props.selected,
          disabled = _this$props.disabled,
          responsive = _this$props.responsive,
          ghost = _this$props.ghost,
          anchor = _this$props.anchor,
          onClick = _this$props.onClick,
          toolbar = _this$props.toolbar,
          primary = _this$props.primary,
          alt = _this$props.alt,
          darkbg = _this$props.darkbg,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "className", "skin", "iconLeft", "iconRight", "fullsize", "selected", "disabled", "responsive", "ghost", "anchor", "onClick", "toolbar", "primary", "alt", "darkbg"]);
      primary = !ghost && (primary || skin === 'primary');
      alt = alt || skin === 'alt';
      var isButton = !(primary || alt || darkbg || toolbar && anchor);
      var classes = (0, _classnames["default"])(className, {
        'zsg-button': isButton,
        'zsg-button_primary': primary,
        'zsg-button_alt': alt,
        'zsg-button_darkbg': darkbg,
        'zsg-button_selected': selected,
        'zsg-button_fullsize': fullsize,
        'zsg-button_static': !responsive,
        'zsg-button_disabled': disabled,
        'zsg-button_ghost': ghost,
        'zsg-toolbar-button': toolbar && !anchor,
        'zsg-toolbar-link': toolbar && anchor
      }); // convert child nodes to actual Array instance

      children = _react["default"].Children.toArray(children);

      if (iconLeft) {
        children.unshift(_react["default"].createElement(LeftIcon, {
          key: "left-icon",
          className: iconLeft
        }));
      }

      if (iconRight) {
        children.push(_react["default"].createElement(RightIcon, {
          key: "right-icon",
          className: iconRight
        }));
      }

      return _react["default"].createElement(anchor ? 'a' : 'button', (0, _objectSpread2["default"])({}, otherProps, {
        className: classes,
        onClick: onClick
      }), children);
    }
  }]);
  return Button;
}(_react["default"].Component);

exports["default"] = Button;
Button.displayName = 'Button';
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,

  /**
   * Additional classnames to add to the button
   */
  className: _propTypes["default"].string,
  skin: _propTypes["default"].oneOf(['primary', 'alt']),

  /**
   * Use when the button is on a dark background/context
   */
  darkbg: _propTypes["default"].bool,

  /**
   * zsg-icon-___ class
   */
  iconLeft: _propTypes["default"].string,

  /**
   * zsg-icon-___ class
   */
  iconRight: _propTypes["default"].string,

  /**
   * always at 100% width
   */
  fullsize: _propTypes["default"].bool,

  /**
   * visual treatment for selected buttons
   */
  selected: _propTypes["default"].bool,

  /**
   * visual treatment for disabled buttons - still fires onClick
   */
  disabled: _propTypes["default"].bool,

  /**
   * set to false to disabled 100% mobile width
   */
  responsive: _propTypes["default"].bool,

  /**
   * gives the button a clear background
   */
  ghost: _propTypes["default"].bool,

  /**
   * passed when this component is composed (nested) inside of a <Toolbar>
   */
  toolbar: _propTypes["default"].bool,

  /**
   * use <a> instead of <button> for the element
   */
  anchor: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,

  /**
   * Deprecated
   */
  primary: (0, _deprecated["default"])(_propTypes["default"].bool, 'Use skin="primary" instead.'),

  /**
   * Deprecated
   */
  alt: (0, _deprecated["default"])(_propTypes["default"].bool, 'Use skin="alt" instead.')
} : {};
Button.defaultProps = {
  responsive: true
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Button/index.js
// module id = 523
// module chunks = 0